export default __webpack_public_path__ + "static/media/outlinedEditDis.86f08a93.svg";